import { formatStartToAPI } from 'src/app/modules/administration/constants/scheduler';

export class ProviderSessionAvailability {
    providerSK?: string;

    startDate?: string;
    startTime?: string;
    endTime?: string;

    recurrenceType?: string;
    interval?: number;
    occurrenceCount?: number;
    endByDate?: string;

    daysOfWeek?: string;
    monthlyPattern?: string;
    monthlyWeekOfMonth?: string;
    monthlyWeekday?: string;
    monthlyDayOfMonth?: number;
    isEditingSession: boolean;
    providerMeetingSk: string;
    isAdd: boolean;
    isSession: boolean;
    recurringMeetingSk: string;
    canceledDate: string;
    editMode: number;
    editScope: string;
    constructor(data: any) {
        this.providerSK = data?.providerSK;
        this.editMode = data?.isAdd ? 0 : 1;
        this.editScope = data?.isEditingSession ? 'ONE' : 'SERIES';
        this.startDate = formatStartToAPI(data?.startDate);
        // const d: Date = new Date(data?.startDate);
        // d?.setDate(d?.getDate());
        // this.startDate = d?.toISOString()?.split('T')[0];
        this.canceledDate = data?.canceledDate;
        this.startTime = data?.startTime;
        this.endTime = data?.endTime;
        this.providerMeetingSk =
            data?.meetingSk !== null &&
                data?.meetingSk !== undefined &&
                data?.meetingSk !== ''
                ? data?.meetingSk
                : null;
        this.isAdd = data?.isAdd;
        this.isSession = data?.isEditingSession ? true : false;
        this.recurringMeetingSk =
            data?.details?.recurringMeetingSk !== null &&
                data?.details?.recurringMeetingSk !== undefined &&
                data?.details?.recurringMeetingSk !== ''
                ? data?.details?.recurringMeetingSk
                : null;


        if (data?.occurences?.id === 1 || this.isSession) {
            this.recurrenceType = null;
            this.interval = 1;
            this.occurrenceCount = null;
            this.endByDate = null;
            this.daysOfWeek = null;
            this.monthlyPattern = null;
            this.monthlyWeekOfMonth = null;
            this.monthlyWeekday = null;
            this.monthlyDayOfMonth = null;
        } else if (data?.occurences?.id === 2) {
            this.recurrenceType = 'DAILY';
            this.interval = data?.occurencesCount;
            this.occurrenceCount = data?.repeatUntilCount ?? null;
            if (data?.endByDate) {
                const d: Date = new Date(data.endByDate);
                d.setDate(d.getDate());
                this.endByDate = d.toISOString().split('T')[0];
            } else {
                this.endByDate = null;
            }
            this.daysOfWeek = null;
            this.monthlyPattern = null;
            this.monthlyWeekOfMonth = null;
            this.monthlyWeekday = null;
            this.monthlyDayOfMonth = null;
        }
        else if (data?.occurences?.id === 3) {
            this.recurrenceType = 'EVERYWEEKDAY';
            this.interval = 1;
            this.occurrenceCount = data?.repeatUntilCount ?? null;
            if (data?.endByDate) {
                const d: Date = new Date(data.endByDate);
                d.setDate(d.getDate());
                this.endByDate = d.toISOString().split('T')[0];
            } else {
                this.endByDate = null;
            }
            this.daysOfWeek = null;
            this.monthlyPattern = null;
            this.monthlyWeekOfMonth = null;
            this.monthlyWeekday = null;
            this.monthlyDayOfMonth = null;
        }
        else if (data?.occurences?.id === 4) {
            this.recurrenceType = 'WEEKLY';
            this.interval = data?.occurencesCount;
            this.occurrenceCount = data?.repeatUntilCount ?? null;
            if (data?.endByDate) {
                const d: Date = new Date(data.endByDate);
                d.setDate(d.getDate());
                this.endByDate = d.toISOString().split('T')[0];
            } else {
                this.endByDate = null;
            }
            this.daysOfWeek = data?.daysOfWeek;
            this.monthlyPattern = null;
            this.monthlyWeekOfMonth = null;
            this.monthlyWeekday = null;
            this.monthlyDayOfMonth = null;
        }
        else if (data?.occurences?.id === 5) {
            this.recurrenceType = 'MONTHLY';
            this.interval = data?.occurencesCount;
            this.occurrenceCount = data?.repeatUntilCount ?? null;
            if (data?.endByDate) {
                const d: Date = new Date(data.endByDate);
                d.setDate(d.getDate());
                this.endByDate = d.toISOString().split('T')[0];
            } else {
                this.endByDate = null;
            }
            this.daysOfWeek = null;
            this.monthlyPattern = data?.monthlyOption === 'onDay' ? 'DAY' : 'NTH';
            this.monthlyWeekOfMonth = data?.monthlyOption === 'onThe' ? data?.weekOrder?.description : null;
            this.monthlyWeekday = data?.monthlyOption === 'onThe' ? data?.weekDay?.description : null;;
            this.monthlyDayOfMonth = data?.monthlyOption === 'onDay' ? data?.dayCount : null;
        }

    }
}


export interface ProviderAvailabilityResponseItem {
    occurrenceDate: string;
    availability: string;
}

